import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
// import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/effect-fade";
import { Skeleton } from "antd";
import { GiSofa } from "react-icons/gi";
import { Pagination } from "swiper/modules";

const Carousal = ({ SubCategoryBanners, SwiperClassName, SkeletonLoad }) => {
  const skeletonArray = Array.from({ length: 1 }, (_, index) => index);
  return (
    <div className={`${SwiperClassName} w-full`}>
      <div className="h-[50vh] min-h-[300px] max-h-[520px] w-full">
      <Swiper
        pagination={true}
        loop={true}
        modules={[Pagination]}
        className="mySwiper h-full w-full"
      >
        {SkeletonLoad ? (
          <div className="mt-5">
            {skeletonArray.map((index) => (
              <div key={index}>
                <Skeleton.Node
                  active={true}
                  style={{ height: "100%", width: "100%" }}
                >
                  <GiSofa style={{ fontSize: 300, color: "#bfbfbf" }} />
                </Skeleton.Node>
              </div>
            ))}
          </div>
        ) : (
          SubCategoryBanners.map((el, i) => {
            if (el.device === "1") {
              return (
                <SwiperSlide key={i} className="h-full w-full">
                  <div className="h-full w-full">
                    <div className="h-full w-full">
                      <img
                        src={
                          process.env.REACT_APP_HAPS_MEDIA_BASE_URL + el.path
                        }
                        alt="Fina Interiors category banner"
                        className="h-full w-full object-cover"
                      />
                    </div>
                  </div>
                  {/* <img
                src={process.env.REACT_APP_HAPS_MEDIA_BASE_URL + el.path}
                alt="" 
                className="object-cover"
              /> */}
                </SwiperSlide>
              );
            } else {
              return null;
            }
          })
        )}
      </Swiper>
      </div>
    </div>
  );
};

export default Carousal;
